// hook
import { get } from 'react-hook-form';
// components
import { NONE } from 'browserify-zlib/lib/binding';
import Label from '../../../components/Label';
import SvgIconStyle from '../../../components/SvgIconStyle';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import { title } from 'process';
import { AuthContext } from 'src/contexts/JWTContext';
import { useContext } from 'react';


// ----------------------------------------------------------------------
function buildMenuItems(user, iconMap) {
  const forms = user?.forms || [];
  const formMap = new Map();
  const result = [];

  const getPath = (pathStr, rootObject) => {
    if (!pathStr || typeof pathStr !== 'string') return null;
    const [, ...keys] = pathStr.split('.');
    return keys.reduce((obj, key) => (obj && obj[key] !== undefined ? obj[key] : null), rootObject);
  };

  // Index all active & non-deleted forms
  forms.forEach(form => {
    if ((user?.role == 'SA' || (form?.permissions?.isView || form?.permissions?.isViewEdit || form?.permissions?.isAdmin)) && form.permissions.isActive && !form.permissions.isDeleted) {
      formMap.set(form.formId, {
        id: form.formId,
        title: form.formName,
        path: getPath(form.formLink, PATH_DASHBOARD),
        icon: iconMap?.[form?.menuIconClass?.split(".")[1]] || null,
        children: []
      });
    }
  });

  // Now build the hierarchy
  formMap.forEach((form, formId) => {
    const originalForm = forms.find(f => f.formId === formId);
    const parentId = originalForm.parentId;

    if (parentId && formMap.has(parentId)) {
      formMap.get(parentId).children.push(form);
    } else {
      result.push(form); // Only root-level forms go here
    }
  });

  // Cleanup empty children arrays and remove path from parent nodes
  const cleanUp = (items) => {
    const sorted = [...items].sort((a, b) => a.title.localeCompare(b.title));
    return sorted.map(item => {
      const newItem = { ...item };
      if (newItem.children.length > 0) {
        delete newItem.path; // Parent nodes shouldn't have a path
        newItem.children = cleanUp(newItem.children); // Recursive cleanup
      } else {
        delete newItem.children; // Remove empty array
      }
      return newItem;
    })
      // A menu form whose link isn't a page in this build (e.g. added to the
      // DB before the page was deployed) has no path: leave it out instead of
      // crashing the whole menu.
      .filter((item) => item.children || typeof item.path === 'string');
  };

  console.log('Final Menu Structure:', cleanUp(result)); // For debugging

  return cleanUp(result);
}

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  sizes: getIcon('ic_sizes'),
  finances: getIcon('ic_finances'),
  promotion_sales: getIcon('ic_promotion_sales'),
  attribute_management: getIcon('ic_attribute_management'),
  supplier_management: getIcon('ic_supplier-management'),
  orders: getIcon('ic_orders'),
  catalog_management: getIcon('ic_catalog_management'),
  customers: getIcon('ic_customers'),
  inbox: getIcon('ic_inbox'),
};

// const navConfig = [
//   // GENERAL
//   // ----------------------------------------------------------------------
//   {
//     subheader: 'general',
//     items: [
//       { title: 'app', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
//       {
//         title: 'Header Menu',
//         icon: ICONS.cart,
//         path: PATH_DASHBOARD.header_menu.root
//       },
      // {
      //   title: 'Attribute Management',
      //   icon: ICONS.cart,
      //   children: [
      //     { title: 'Attribute Type', path: PATH_DASHBOARD.attribute_type.root },
      //     { title: 'Attribute Preset Management', path: null,
      //       children : [
      //         { title : 'Style Preset', path: PATH_DASHBOARD.attribute_preset.stylePreset },
      //         { title : 'Sub Style Preset', path: PATH_DASHBOARD.attribute_preset.subStylePreset }
      //       ]
      //     }
      //   ],
      // },
//       {
//         title: 'Fabric Management',
//         icon: ICONS.cart,
//         children: [
//           { title: 'Fabrics', path: PATH_DASHBOARD.fabric.list },
//           { title: 'Fabrics Category', path: PATH_DASHBOARD.fabricCategory.list },
//           { title: 'Fabrics Compatibility Profile', path: PATH_DASHBOARD.fabric.compatibilityprofilelist },
//           { title: 'Fabrics Properties', path: PATH_DASHBOARD.fabricProperties.list },
//         ],
//       },
//       {
//         title: 'Global System Variables',
//         icon: ICONS.cart,
//         path: PATH_DASHBOARD.accent_contrast.root
//       },
//       {
//         title: 'Order Management',
//         icon: ICONS.orders,
//         children: [
//           { title: 'Orders', path: PATH_DASHBOARD.order.list },
//           { title: 'Fit Advice Request', path: PATH_DASHBOARD.order.list },
//         ],
//       },
//       {
//         title: 'Sizes',
//         icon: ICONS.sizes,
//         children: [
//           { title: 'Sizewiz', path: PATH_DASHBOARD.sizes.sizewiz },
//           { title: 'Standard Sizes', path: PATH_DASHBOARD.sizes.standard_sizes },
//           { title: 'Measure Your Body', path: PATH_DASHBOARD.sizes.measure_your_body },
//           { title: 'Measure Your Shirt', path: PATH_DASHBOARD.sizes.measure_your_shirt },
          
//         ],
//       },
//       {
//         title: 'Supplier Management',
//         icon: ICONS.supplier_management,
//         children: [
//           { title: 'Suppliers', path: PATH_DASHBOARD.supplier.list },
//           { title: 'Api Configuration', path: PATH_DASHBOARD.apiConfiguration.list },
//         ],
//       },
//       {
//         title: 'User Permissions & Roles',
//         icon: ICONS.user,
//         children: [
//           { title: 'Users', path: PATH_DASHBOARD.user.list },
//           { title: 'User Roles', path: PATH_DASHBOARD.user.userRole },
//         ],
//       },
//       {
//         title: 'Catalog Management',
//         icon: ICONS.catalog_management,
//         children: [
//           { title: 'products', path: PATH_DASHBOARD.product.list },
//           { title: 'category', path: PATH_DASHBOARD.category.list },
//           { title: 'Sub category', path: PATH_DASHBOARD.sub_category.list },
//           { title: 'collection', path: PATH_DASHBOARD.collection.list },
//           { title: 'product group', path: PATH_DASHBOARD.grouping.list },
//           { title: 'Product XML Profile', path: PATH_DASHBOARD.product_xml.list },
//           { title: 'Product Features', path: PATH_DASHBOARD.product_features.list }
//         ],
//       },
//       {
//         title: 'Promotion Sales',
//         icon: ICONS.promotion_sales,
//         children: [
//           { title: 'Discounts/Promotions', path: PATH_DASHBOARD.discount_promotion.list },
//           { title: 'Vouchers', path: PATH_DASHBOARD.voucher.list },
//           { title: 'Gift Cards', path: PATH_DASHBOARD.gift_card.list },
//           { title: 'Purchase Gift Cards', path: PATH_DASHBOARD.purchased_gift_card.list },
//         ],
//       },
//       {
//         title: 'Business Analytics',
//         icon: ICONS.analytics,
//         children: [
//           { title: 'Customer Reports', path: PATH_DASHBOARD.general.analytics },
//           { title: 'Sales Reports', path: PATH_DASHBOARD.general.analytics},
//         ],
//       },
//       { title: 'Review', path: PATH_DASHBOARD.review.list, icon: ICONS.customers },
//       { title: 'Customers', path: PATH_DASHBOARD.customer.list, icon: ICONS.customers },
//       { title: 'Inbox', path: PATH_DASHBOARD.chat.root, icon: ICONS.inbox },
//       { title: 'Finances', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.finances },
//     ],
//   },
// ];
const useNavConfig = () => {
  const { user } = useContext(AuthContext);
  // const forms = user?.forms || [];

  return [
    {
      subheader: 'general',
      items: buildMenuItems(user, ICONS),
    }
  ];
};

export default useNavConfig;
